import { render, staticRenderFns } from "./Stocks_Insuficientes_Informacion.vue?vue&type=template&id=60e3afe9&scoped=true"
import script from "./Stocks_Insuficientes_Informacion.vue?vue&type=script&lang=js"
export * from "./Stocks_Insuficientes_Informacion.vue?vue&type=script&lang=js"
import style0 from "./Stocks_Insuficientes_Informacion.vue?vue&type=style&index=0&id=60e3afe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3afe9",
  null
  
)

export default component.exports